import React from 'react';
import { Container } from './ui/Container';
import { Moon, Heart, Battery, ShieldCheck, Zap, Smile } from 'lucide-react';
import { Button } from './ui/Button';
const benefits = [{
  icon: Moon,
  title: 'Stop Snoring Naturally',
  desc: 'No machines, masks, or invasive procedures.'
}, {
  icon: Heart,
  title: 'Sleep in the Same Bed',
  desc: 'End the separate rooms and loneliness.'
}, {
  icon: Battery,
  title: 'Wake Up Rested',
  desc: 'Experience deeper, uninterrupted sleep.'
}, {
  icon: Smile,
  title: 'Save Your Relationship',
  desc: 'No more morning fights or resentment.'
}, {
  icon: Zap,
  title: 'Comfortable from Night One',
  desc: 'Soft, moldable fit that feels natural.'
}, {
  icon: ShieldCheck,
  title: 'Risk-Free Trial',
  desc: '90-day money-back guarantee.'
}];
export function BenefitsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-white" data-id="element-1">
      <Container data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-4">
            What You'll Experience
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-5"></div>
        </div>

        {/* Hero Lifestyle Image */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-16 h-[400px] md:h-[500px]" data-id="element-6">
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent z-10" data-id="element-7"></div>
          <img src="https://cdn.magicpatterns.com/uploads/ucyfC3msYKWzV4hpVgap4d/imgi_17_1746975327-4.png" alt="Peaceful couple sleeping" className="w-full h-full object-cover" data-id="element-8" />
          <div className="absolute bottom-8 left-8 right-8 z-20 text-white" data-id="element-9">
            <h3 className="text-2xl md:text-4xl font-bold mb-2" data-id="element-10">
              The Silence You've Been Dreaming Of
            </h3>
            <p className="text-lg text-blue-100 max-w-2xl" data-id="element-11">
              Wake up loving your partner again, not resenting them.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-12">
          {benefits.map((benefit, index) => <div key={index} className="bg-gray-50 p-8 rounded-2xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1 border border-gray-100" data-id="element-13">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 text-blue-600 shadow-sm border border-gray-100" data-id="element-14">
                <benefit.icon className="w-7 h-7" data-id="element-15" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-16">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-17">{benefit.desc}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-18">
          <Button onClick={scrollToPricing} size="lg" className="shadow-lg shadow-blue-900/20 px-10 py-4 text-lg" data-id="element-19">
            Get SnoreStop™ Now
          </Button>
        </div>
      </Container>
    </section>;
}